<template>
    <div class="pricing-container">
        <div class="pricing-box blue">
            <div class="pricing-name">
                standard
            </div>
            <div class="pricing-price">
                $4.99<span>/month</span>
            </div>
            <div class="pricing-details">
                15 scans / day
            </div>
            <a class="pricing-btn" href="#">
                Select Plan
            </a>
        </div>
        <div class="pricing-box">
            <div class="pricing-name">
                pro hacker
            </div>
            <div class="pricing-price">
                $9.99<span>/month</span>
            </div>
            <div class="pricing-details">
                50 scans / day
            </div>
            <div class="pricing-details">
                Private file scan option
            </div>
            <a class="pricing-btn blue" href="#">
                Select Plan
            </a>
        </div>
        <div class="pricing-box blue">
            <div class="pricing-name">
                business
            </div>
            <div class="pricing-price">
                Custom
            </div>
            <div class="pricing-details">
                
            </div>
            <a class="pricing-btn" href="#">
                Select Plan
            </a>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Pricing' 
}
</script>